module.exports = "/_next/static/images/dbd2ece53b03c5d5d67619b42a20fbda-service-payment.png";